import { useState, useCallback } from "react";
import { MinusIcon, CrossIcon } from "../../../assets/icons";
import FileUploadSection from "../../FileUploadSection/FileUploadSection";
import { uploadFile, createLayer, getLayer } from "../../../api";
import { toast } from "react-toastify";
import SpinnerLoading from "../../SpinnerLoading/SpinnerLoading";
import LayerMatchSection from "./LayerMatchSection/LayerMatchSection";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../Context/AppContext";
import "./LayerUploadModal.scss";

const LayerUploadModal = ({
  title,
  selectedComune,
  closeModal,
  handleFileUpload,
}) => {
  const [uploadFileId, setUploadFileId] = useState(null);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [matchData, setMatchData] = useState({
    chiave: "",
    tipo: "",
    selectedCrs: { value: "EPSG:32633", label: "EPSG:32633" },
    comuneId: selectedComune?.id,
    crs: "EPSG:32633",
    zipId: null,
    color: "rgb(77, 80, 79)",
  });
  const navigate = useNavigate();
  const { setLayers, mapViewTarget, setMapViewTarget } = useAppContext();

  const handleSelectCrsChange = useCallback((selectedCrs) => {
    setMatchData((prev) => ({ ...prev, selectedCrs, crs: selectedCrs.value }));
  }, []);

  const handleInputChange = useCallback((ev) => {
    setMatchData((prev) => ({ ...prev, [ev.target.name]: ev.target.value }));
  }, []);

  const handleLayerSave = useCallback(async () => {
    setIsFileUploading(true);
    try {
      const layerResponse = await createLayer({ ...matchData, style: { stroke: { color: matchData.color, width: 1 } } });
      const layer = await getLayer(layerResponse.id);

      if (layer)
        toast.success(
          `${layer?.features?.length} feature sono state caricate con successo:`
        );

      // Reset layers before forceing reload
      setLayers([]);
      
      // Force mapViewTarget update to trigger layer reload

      const currentTarget = { ...mapViewTarget } || { 
        layer: selectedComune?.nome === 'ITALIA' ? "comuni" : "limiti", 
        comune: selectedComune 
      };
  
    
      // Use setTimeout to ensure state updates are processed
      setTimeout(() => {
        setMapViewTarget(currentTarget);
        navigate("/MapView");
        closeModal();
      }, 20);

    } catch (error) {
      toast.error(`Error: ${error.message}`);
    } finally {
      setIsFileUploading(false);
    }
  }, [matchData, closeModal]);

  const handleCSVXlsUpload = useCallback(async (ev) => {
    const files = ev.target.files;
    if (files.length) {
      setIsFileUploading(true);
      Array.from(files).forEach(async (file) => {
        const reader = new FileReader();
        reader.onload = async function () {
          try {
            const fileId = await uploadFile(file);
            setUploadFileId(fileId);
            setMatchData((prev) => ({ ...prev, zipId: fileId }));
          } catch (error) {
            toast.error(`Error: ${error.message}`);
          } finally {
            setIsFileUploading(false);
          }
        };

        if (file.name.endsWith(".zip")) {
          reader.readAsBinaryString(file);
        } else {
          console.error("Unsupported file format.");
          setIsFileUploading(false);
        }
      });
    }
  }, []);

  console.log("+++> MatchData:", matchData);

  return (
    <section className="layer-upload-modal-container">
      <header className="modal-header">
        <div className="modal-header-content">
          <h1 className="modal-title">{title}</h1>
          <div className="modal-icons">
            <div className="modal-icon" onClick={closeModal}>
              <MinusIcon />
            </div>
            <div className="modal-icon" onClick={closeModal}>
              <CrossIcon />
            </div>
          </div>
        </div>
      </header>

      <div className="layer-upload-modal-body">
        <FileUploadSection
          handleUpload={handleCSVXlsUpload}
          acceptType={".zip"}
        />

        {uploadFileId ? (
          <LayerMatchSection
            selectedComune={selectedComune}
            chiave={matchData?.chiave}
            tipo={matchData?.tipo}
            selectedCrs={matchData?.selectedCrs}
            color={matchData?.color}
            handleCrsChange={handleSelectCrsChange}
            handleInputChange={handleInputChange}
          />
        ) : null}
      </div>

      {/* footer */}
      {uploadFileId ? (
        <footer className="modal-footer">
          <button className="modal-footer-button" onClick={handleLayerSave}>
            Save
          </button>
        </footer>
      ) : null}
      <SpinnerLoading isLoading={isFileUploading} />
    </section>
  );
};

export default LayerUploadModal;
